import { graphql } from "gql.tada";
import { LinkFragment } from "./LinkFragment";

export const PartnershipListItemFragment = graphql(`
  fragment PartnershipListItemFragment on PartnershipListItem {
    eyebrowText
    title
    exploreCta
    link {
      ...LinkFragment
    }
    logo { url }
    videoPosterImage { url }
    video { url }
  }
`, [LinkFragment]);
